// Stores a private copy of original vertex positions on the mesh before procedural resizers mutate geometry.
export function recordOriginalGeometryPositions(
  mesh,
  positionsTag = 'origGeometryPositions',
  minYTag = 'origGeometryMinY',
  maxYTag = 'origGeometryMaxY'
) {
  const position = mesh.geometry && mesh.geometry.attributes && mesh.geometry.attributes.position;

  if (!position || !position.array) {
    return null;
  }

  if (mesh.userData[positionsTag]) {
    return {
      positions: mesh.userData[positionsTag],
      minY: minYTag ? mesh.userData[minYTag] : null,
      maxY: maxYTag ? mesh.userData[maxYTag] : null,
    };
  }

  mesh.geometry = mesh.geometry.clone();

  const clonedPosition = mesh.geometry.attributes.position;
  const originalPositions = new Float32Array(clonedPosition.array);
  let localMinY = Infinity;
  let localMaxY = -Infinity;

  for (let index = 1; index < originalPositions.length; index += 3) {
    localMinY = Math.min(localMinY, originalPositions[index]);
    localMaxY = Math.max(localMaxY, originalPositions[index]);
  }

  mesh.userData[positionsTag] = originalPositions;

  if (minYTag) {
    mesh.userData[minYTag] = localMinY;
  }

  if (maxYTag) {
    mesh.userData[maxYTag] = localMaxY;
  }

  return {
    positions: originalPositions,
    minY: localMinY,
    maxY: localMaxY,
  };
}

export function restoreOriginalGeometry(mesh, positionsTag = 'origGeometryPositions') {
  let originalPositions = mesh.userData[positionsTag];
  const position = mesh.geometry && mesh.geometry.attributes && mesh.geometry.attributes.position;

  if (!originalPositions || !position || !position.array) {
    return;
  }

  // Object3D.clone() serializes userData, turning typed arrays into objects
  // with numeric keys. Normalize cloned baselines before restoring geometry.
  if (typeof originalPositions.length !== 'number' && typeof originalPositions === 'object') {
    originalPositions = Float32Array.from(Object.values(originalPositions));
    mesh.userData[positionsTag] = originalPositions;
  }

  position.array.set(originalPositions);
  position.needsUpdate = true;
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeBoundingSphere();
}
